import { Graphic } from "./Graphic";
import { StageScene } from "./StageScene";
import { BLL } from "./stages/BLL";
import { Dumeus } from "./stages/Dumeus";
import {VideoScene} from "./VideoScene";
import { text } from "./text";
import {TriggerScene} from "./TriggerScene";
import * as d3 from "d3";


function getVidUrl() {
    return `./${window.isMobile.any ? "mobile" : "desktop"}.mp4`
}

function getVidEl() {
    const vidEl = document.createElement("video")
    vidEl.setAttribute("preload", "auto");
    vidEl.setAttribute("muted", "");
    vidEl.setAttribute("autoplay", "");
    vidEl.setAttribute("playsinline", "");
    vidEl.playsinline = true;
    vidEl.autoplay = true;
    vidEl.preload = "auto";
    vidEl.muted = true;
    vidEl.classList.add("under-vid");
    vidEl.src = getVidUrl();
    vidEl.load();
    return vidEl;
}



async function main() {

    let bllData = await d3.csv("./dumeus_blood_tests.csv", x => {
        return {
            bll: +x.bll,
            cbli: +x.cbli,
            cumulative_trap: +x.cumulative_trap,
            date: d3.isoParse(x.date),
            lower: +x.lower,
            upper: +x.upper,
            trapezoid: +x.trapezoid,
            id: x.id,
            days_since_last: +x.days_since_last
        }
    })

    let airData = await d3.csv("./furnace_air.csv", x => {
        return {
            date: d3.isoParse(x.date),
            id: x.id,
            result: +x.result,
            exceeds_8hr_muc: +x.result > 2500
        }
    })

    const g = new Graphic({
        scenes: {
            "drone": new VideoScene({
                screenLengths: 24,
                framerate: 30,
                vidEl: getVidEl(),
                frameSteps: window.isMobile.any ? 10 : 20,
                // steps,
                numFrames: 720
            }),
            "d3": new TriggerScene({
                screenLengths: 9,
                data: {bllData, airData}
            })
            // "bll": new StageScene({
            //     screenLengths: 19,
            //     stages: {
            //         "all_bloods": BLL,
            //         // "dumeus": Dumeus,
            //     },
            //     stageOrder: ["all_bloods"]
            // })
        },
        sceneOrder: [
            "drone",
            "d3"
        ],
        mountPoint: "graphic",
        debug: true,
        text
    })
    // await document.body.requestFullscreen();
    g.mount("graphic")
    return
}

main().then(console.log)